import { useEffect } from "react";

const useLeavePrompt = (shouldOpenPrompt = true) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (shouldOpenPrompt) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldOpenPrompt]);
};

export default useLeavePrompt;
